import React from 'react';

interface PageComponentMainHeaderProps {
  header: string;
  caption?: string;
  subHeader?: string;
  className?: string;
}

export const PageComponentMainHeader = ({
  header,
  caption,
  className,
  subHeader,
}: PageComponentMainHeaderProps) => {
  return (
    <div className={`flex-column ${className}`}>
      {subHeader && (
        <h3 className="mb-2 font-title text-headings text-text-light">
          {subHeader}
        </h3>
      )}
      <h1 className="mb-2 font-title text-headingm text-text-default lg:text-headingl">
        {header}
      </h1>
      {caption && (
        <h2 className={`font-title text-headings lg:text-headingm`}>
          {caption}
        </h2>
      )}
    </div>
  );
};
